/** Copyright (c) 2020 T.Rowe Price. All rights reserved. */

import './AccountLayoutHeader.scss';

import classnames from 'classnames';

import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { string, bool } from 'prop-types';
import { ReactComponent as HeaderDetailsIcon } from 'assets/icons/portfolio-details.svg';
import { ReactComponent as SubHeaderDetailsIcon } from 'assets/icons/management-style-details.svg';
import Store from 'state/Store';
import { filterAccountsGridAccountType } from 'state/account/AccountsGridFilteringActions';

const AccountLayoutHeader = ({
  text,
  link,
  detailText,
  isSubheader,
  className,
  hideDetailLink,
  hideIcon
}) => {
  const kind = isSubheader
    ? 'account-layout-sub-header'
    : 'account-layout-header';
  const headerClassName = classnames(kind, className);

  const selectAllAccounts = () => {
    Store.dispatch(filterAccountsGridAccountType('all'));
  };

  return (
    <div className={headerClassName}>
      <div className="header-name">{text}</div>
      {!hideDetailLink && (
        <div className="header-link">
          <Link
            className="header-details-link"
            onClick={selectAllAccounts}
            to={link}>
            <span className="header-details-name">{detailText}</span>
            {!hideIcon &&
              (isSubheader ? (
                <SubHeaderDetailsIcon className="sub-header-details-svg" />
              ) : (
                <HeaderDetailsIcon className="header-details-svg" />
              ))}
          </Link>
        </div>
      )}
    </div>
  );
};

AccountLayoutHeader.propTypes = {
  text: string.isRequired,
  link: string,
  detailText: string,
  isSubheader: bool,
  className: string,
  hideDetailLink: bool
};

AccountLayoutHeader.defaultProps = {
  detailText: '',
  isSubheader: true,
  className: '',
  hideDetailLink: false
};

export default withRouter(AccountLayoutHeader);
